import PurchaseLicenseModal from './PurchaseLicenseModal';

export default PurchaseLicenseModal;
